import { render, staticRenderFns } from "./explanatoryText.vue?vue&type=template&id=4bd3180e&scoped=true&"
import script from "./explanatoryText.vue?vue&type=script&lang=ts&"
export * from "./explanatoryText.vue?vue&type=script&lang=ts&"
import style0 from "./explanatoryText.vue?vue&type=style&index=0&id=4bd3180e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd3180e",
  null
  
)

export default component.exports